/**
 * Which past day this tab is playing from the calendar (DLY-005).
 *
 * Kept in `sessionStorage`, not the URL: the address bar stays the bare site (URL-001,
 * the owner's choice), and the choice lasts only as long as this tab. A reload stays on
 * the archive day; a new tab, or "Today", goes back to today's table.
 *
 * Untrusted like any stored value (CLAUDE.md §10): read back through `isDayKey`, and the
 * server still refuses any day after its own today, so editing it reveals nothing.
 */
import { isDayKey } from '../daily/today.ts';

const KEY = 'potted.archive-day';

function session(): Storage | undefined {
  try {
    return window.sessionStorage;
  } catch {
    return undefined;
  }
}

export function readArchiveDay(): string | undefined {
  try {
    const value = session()?.getItem(KEY) ?? null;
    return isDayKey(value) ? value : undefined;
  } catch {
    return undefined;
  }
}

export function chooseArchiveDay(dateKey: string): void {
  try {
    session()?.setItem(KEY, dateKey);
  } catch {
    // Storage blocked: the calendar cannot open a past day in this browser. Today still works.
  }
}

export function clearArchiveDay(): void {
  try {
    session()?.removeItem(KEY);
  } catch {
    // Nothing stored, nothing to clear.
  }
}
